import React from "react";
import PurchaseContainer from "../containers/Purchase";
import MainLayout from "../layouts/MainLayout";

const Purchase = () => {
  return (
    <MainLayout>
      <PurchaseContainer />
    </MainLayout>
  );
};

export default Purchase;
